export const expenseSearch = {
  user: ["user", "fullName"],
  receiver: ["receiver", "fullName"],
  category: ["category", "name"],
  description: ["description"],
  amount: ["amount"],
  status: ["state"],
};
export const visitSearch = {
  user: ["station", "id"],
  site: ["station", "name"],
  category: ["category", "name"],
  fieldTechnician: ["fieldTechnician", "fullName"],
  workDone: ["workDone"],
  status: ["status"],
};

export const siteSearch = {
  user: ["id"],
  site: ["name"],
  category: ["category", "name"],
};

export const machineSearch = {
  id: ["id"],
  machine: ["station", "name"],
};

export const uploadSheetSearch = {
  user: ["createdBy", "fullName"],
};
export const cylinderSiteSearch = {
  station: ["name"],
  id: ["id"],
  jbccFt: ["jbccFieldTechnician", "fullName"],
};

export const discardedCylinderSearch = {
  number: ["serialNo"],
  discardReason: ["reasonForDiscard"]
};

export const SITE_REAPER_SEARCH_OPTIONS = {
  user: ["station", "id"],
  site: ["station", "name"],
  machineId: ["station", "machineID"],
};